import PropTypes from "prop-types";
import DateCalendarInput from "app/pages/SmartDP/Search/DateCalendarInput/DateCalendarInput";
import { memo, useCallback, useEffect } from "react";
import { addDays, format } from "date-fns";
import { useField } from "formik";
import { SDP_ROTATION_DATE_FORMAT } from "app/constants";
import { isDateWithinRange } from "app/utils/utils";

const MAX_CALENDAR_DATE_OFFSET = 340;
const MIN_BOOKING_DATE_OFFSET = 1;
const MAX_BOOKING_DATE_OFFSET = 30;

const HotelOnlyDateCalendarContainer = props => {
	const {
		updateFloatingPositionReference = () => {},
		handleDayChange = () => {},
		popperOffset = [],
	} = props;
	const [field] = useField(props);
	const [destinationResortField] = useField("destinationResort");

	const selectedDepartureDate = field.value?.departureDate;
	const selectedEndDate = field.value?.endDate;

	const today = new Date();

	const hotelOnlyCalendarMinDate = format(today, SDP_ROTATION_DATE_FORMAT);
	const hotelOnlyCalendarMaxDate = format(
		addDays(today, MAX_CALENDAR_DATE_OFFSET),
		SDP_ROTATION_DATE_FORMAT
	);
	const calendarMinDate = hotelOnlyCalendarMinDate;
	let calendarMaxDate = hotelOnlyCalendarMaxDate;
	const maxSelectableDate = addDays(new Date(selectedDepartureDate), MAX_BOOKING_DATE_OFFSET);

	if (selectedDepartureDate && !selectedEndDate) {
		calendarMaxDate = format(maxSelectableDate, SDP_ROTATION_DATE_FORMAT);
	}
	const isCalendarDisabled = !destinationResortField.value;

	const checkDateAvailability = useCallback(date => {
		if (isCalendarDisabled) {
			return true;
		}
		if (selectedDepartureDate && !selectedEndDate) {
			const minEndDate = addDays(new Date(selectedDepartureDate), MIN_BOOKING_DATE_OFFSET);

			// Enable valid end dates : [departure + 1, departure + 30]
			if (isDateWithinRange(date, minEndDate, maxSelectableDate)) {
				return false;
			}
			// Enable anterior re-selection as new departure : [today, departure]
			if (isDateWithinRange(date, today, selectedDepartureDate)) {
				return false;
			}
			return true;
		}

		return false;
	});
	useEffect(() => {
		if (selectedDepartureDate && selectedEndDate) {
			handleDayChange({
				selectedEndDate,
				selectedDepartureDate,
			});
		} else if (!selectedDepartureDate && !selectedEndDate) {
			handleDayChange({
				selectedEndDate,
				selectedDepartureDate,
			});
		}
	}, [selectedDepartureDate, selectedEndDate]);

	return (
		<DateCalendarInput
			{...props}
			departureDateMin={calendarMinDate}
			departureDateMax={calendarMaxDate}
			updateFloatingPositionReference={updateFloatingPositionReference}
			checkDateAvailability={checkDateAvailability}
			handleDayChange={handleDayChange}
			isCalendarDisabled={isCalendarDisabled}
			popperOffset={popperOffset}
			displayCalendarIcon={false}
			displayFooterLabel={false}
		/>
	);
};

HotelOnlyDateCalendarContainer.propTypes = {
	updateFloatingPositionReference: PropTypes.func,
	handleDayChange: PropTypes.func,
	popperOffset: PropTypes.array,
};

export default memo(HotelOnlyDateCalendarContainer);
